module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/v2_common/save-o-c79e870dc593461fff00d6227aae53dd.svg";